export default [
  {
    label: "Dashboard de negócio",
    to: "/deals/business-dashboard",
    icon: "fas fa-chart-bar",
    controller: "InternalDashboard",
    action: "GetBusiness"
  },
  {
    label: "Dashboard de marketplace",
    to: "/deals/marketplace-dashboard",
    icon: "fas fa-store-alt",
    controller: "InternalDashboard",
    action: "GetMarketplace"
  },
  {
    separator: true
  },
  {
    label: "Negociações em andamento",
    to: "/deals/prospects",
    icon: "fas fa-id-badge",
    controller: "Prospect",
    action: "List"
  },
  {
    label: "Maquininhas",
    to: "/deals/merchantmaquina",
    icon: "fas fa-cash-register",
    controller: "MerchantMaquina",
    action: "List"
  },
  {
    label: "Estoque Maquinas",
    to: "/deals/maquina",
    icon: "fas fa-cash-register",
    controller: "Maquina",
    action: "List"
  },
  {
    label: "Clientes",
    to: "/deals/clients",
    icon: "fas fa-user-check",
    controller: "Merchant",
    action: "List"
  },
  {
    label: "Pré-cadastro",
    to: "/deals/pre-clients",
    icon: "fas fa-user-lock",
    controller: "MerchantPreview",
    action: "List"
  },
  {
    separator: true
  },
  {
    label: "Parceiros",
    to: "/deals/partners",
    icon: "fas fa-handshake",
    controller: "Partner",
    action: "List"
  },
  {
    label: "Usuários dos Clientes",
    to: "/deals/clients/merchant-user",
    icon: "fas fa-user",
    controller: "MerchantUser",
    action: "List"
  },
  // {
  //   label: "Negociações",
  //   to: "/deals/negotiation",
  //   icon: "fas fa-atlas",
  //   controller: "MerchantNegotiation",
  //   action: "List"
  // },
  {
    separator: true
  },
  {
    label: "Resultado dos anúncios",
    to: "/deals/merchant-campaigns",
    icon: "fas fa-bullhorn",
    controller: "Campaign",
    action: "ListMerchant"
  }
];


// WEBPACK FOOTER //
// ./src/data/menu-item-internal/business-menu.js